<template>
    <div class="container">
        <section class="section">
        <h2>Contact</h2>
        <p>Got a comment or question</p>
        Email: <a mailto="siteadmin@varproto.com">siteadmin@varproto.com</a>
        </section>
    </div>
</template>

<script>
export default {
    name: "Contact"
}
</script>

<style lang="sass">
$font-stack:    Arial, sans-serif
$primary-color: #333
</style>